import { render, staticRenderFns } from "./MobileApp.vue?vue&type=template&id=548cd26e&scoped=true&lang=html&"
import script from "./MobileApp.vue?vue&type=script&lang=js&"
export * from "./MobileApp.vue?vue&type=script&lang=js&"
import style0 from "./MobileApp.vue?vue&type=style&index=0&id=548cd26e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548cd26e",
  null
  
)

export default component.exports